import React, { useCallback } from 'react';

import { getPopperProps } from '../../utils/menus';
import { MentionsPopoverProps } from './types';
import { useMenuItemClick } from './useMentionsPopover';
import { closeDialog } from './utils';

const POPOVER_MAX_HEIGHT = 440;

function MentionsPopover(props: MentionsPopoverProps) {
  const { open, ListComponent, editorView, match } = props;

  const onItemClick = useMenuItemClick(editorView, match);

  const onDialogClose = useCallback(() => {
    closeDialog(editorView.state, editorView.dispatch);
    editorView.focus();
  }, [editorView]);

  const onFocus = useCallback(() => {
    editorView.focus();
  }, [editorView]);

  if (!open || !editorView) {
    return null;
  }

  return (
    <ListComponent
      focusEditor={onFocus}
      popperProps={getPopperProps({ editorView, maxHeight: POPOVER_MAX_HEIGHT })}
      searchString={match}
      onClose={onDialogClose}
      onItemClick={onItemClick}
    />
  );
}

export default MentionsPopover;
